import { reactive } from "vue";
import { startParse, waitForParse } from "./parseJobs.js";

const MAX_ENTRIES = 30;

// File des ajouts d'annonces lancés pendant la session.
// Module partagé : la liste survit aux changements de page.
export const parseQueue = reactive({ entries: [] });

let nextId = 1;

// Lance l'ajout sans bloquer l'utilisateur ; le résultat arrive dans l'entrée.
// status : "pending" | "done" | "failed" | "timeout"
export function enqueueParse(url, notify = true) {
  const existing = parseQueue.entries.find(
    (entry) => entry.url === url && entry.status === "pending"
  );
  if (existing) return existing;

  const entry = reactive({
    id: nextId++,
    url,
    status: "pending",
    error: "",
    offerId: null,
  });
  parseQueue.entries.unshift(entry);
  parseQueue.entries.splice(MAX_ENTRIES);

  (async () => {
    try {
      const jobId = await startParse(url, notify);
      const outcome = await waitForParse(jobId);
      entry.offerId = outcome.offerId;
      entry.error = outcome.error || "";
      entry.status =
        outcome.status === "Completed" ? "done" : outcome.status === "Failed" ? "failed" : "timeout";
    } catch (error) {
      entry.status = "failed";
      entry.error =
        error.response?.data?.message ||
        error.response?.data?.error ||
        "Le service est momentanément indisponible.";
    }
  })();

  return entry;
}

export function clearFinishedParses() {
  parseQueue.entries = parseQueue.entries.filter((entry) => entry.status === "pending");
}
